import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DashboardWrapperStyled = styled.div`
  margin: 0 auto;
`;

export const TableWrapperStyled = styled.div`
  border: 1px solid ${colors.neutral[200]};
  border-top: none;
  padding: 0 2.4rem;
  box-sizing: border-box;
`;
